<template>
	<div class="modal fade" id="exportDialog" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static"
		aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered modal-sm" role="document">
			<div class="modal-content dialog-content">
				<div class="modal-body">
					<button id="btnCloseReportsDialog" type="button" class="close" data-dismiss="modal"
						aria-label="Close" style="z-index: 9">
						<span aria-hidden="true">&times;</span>
					</button>
					<div class="container-fluid">
						<div class="row report-row">
							<div class="col-6">
								<div class="form-check">
									<input type="radio" class="form-check-input" id="cbctExportCheck" name="fileType"
										value="cbctUrl" v-model="exportUrlType">
									<!-- -->
									<label class="form-check-label" for="cbctExportCheck">Original CBCT</label>
								</div>
							</div>
							<div class="col-6">
								<div class="form-check">
									<input type="radio" class="form-check-input" id="iosExportCheck" name="fileType"
										value="iosUrl" v-model="exportUrlType">
									<label class="form-check-label" for="iosExportCheck">Original IOS</label>
								</div>
							</div>
						</div>
						<div class="row report-row">
							<div class="col-6">
								<div class="form-check">
									<input type="radio" class="form-check-input" id="stitchedExportCheck"
										name="fileType" value="stitchedUrl" v-model="exportUrlType">
									<label class="form-check-label" for="stitchedExportCheck">Stitched
										Segmentation</label>
								</div>
							</div>

							<div class="col-6">
								<div class="form-check">
									<input type="radio" class="form-check-input" id="nonStitchedExportCheck"
										name="fileType" value="nonStitchedUrl" v-model="exportUrlType">
									<!--  checked -->
									<label class="form-check-label" for="nonStitchedExportCheck">Non Stitched
										Segmentation</label>
								</div>
							</div>

						</div>

						<div class="row report-row">
							<div class="col-6">
								<div class="form-check">
									<input type="radio" class="form-check-input" id="airwayExportCheck" name="fileType"
										value="airwayReportUrl" v-model="exportUrlType">
									<label class="form-check-label" for="airwayExportCheck">Airway Report</label>
								</div>
							</div>
						</div>


						<div class="row">
							<div class="col-12">
								<button id="btnGetFile" class="btn btn-primary" aria-label="Get File"
									v-on:click="getFile()">GET FILE</button>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<small id="hintGetReport" class="form-text">Press button to get file</small>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import {
	getZipByUrlType
} from "./ReportsManager";

export default {
	name: "ExportDialog",
	props: ["exportUrlType"],
	// data() {
	// 	return {
	// 		exportUrlType: "nonStitchedUrl",
	// 	};
	// },
	computed: {
		stitchedSelected() {
			return false;
		},
	},
	methods: {
		getFile: function () {
			getZipByUrlType(this.exportUrlType);
			$("#exportDialog").modal("hide");
		}
	}
};
</script>

<style scoped>
.report-split-line {
	margin-left: -15px;
	margin-top: 15px;
	margin-bottom: 0;
	border-top: 1px solid grey;
}

.report-row {
	margin-left: 5px;
}

.modal-sm {
	max-width: 400px;
}

.dialog-content {
	background-color: #ffffff;
}

.close {
	margin-right: -8px;
	margin-top: -10px;
}

.row {
	margin-top: 20px;
}

.btn {
	width: 100%;
	border-radius: 0px;
	height: 40px;
	background-color: #0069d9;
}

#hintGetReport {
	text-align: center;
	color: green;
	font-size: smaller;
	margin-top: -10px;
}

/* input[type="checkbox"] {
	-webkit-appearance: none;
	-moz-border-radius: 0px;
	-webkit-border-radius: 0px;
	border-radius: 0px;
} */
</style>
